import React, { Fragment, useState, useEffect } from "react";
import {
  Breadcrumb,
  Typography,
  Divider,
  Input,
  Drawer,
  Space,
  Button,
  Table,
  Avatar,
  Popconfirm,
  Row,
  Col,
} from "antd";
import { DeleteOutlined, EditFilled, PlusCircleOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import moment from "moment";
import seekSolutionApi from "../../utils/seekSolutionApi";
import { Link } from "react-router-dom";
import uiSettings from "../../utils/uiSettings";
import { useContentContext } from "../../context/ContentContext";
import GetImage from "../../utils/GetImage";

const { Title } = Typography;
const { Search } = Input;

const EventListing = () => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [loadingId, setLoadingId] = useState("");
  const [loading, setLoading] = useState(false);
  const { Toast } = useContentContext();
  const [state, setState] = useState({
    Count: 0,
    ScannedCount: 0,
    Items: [],
  });
  const [defaultState, setDefaultState] = useState({
    Count: 0,
    ScannedCount: 0,
    Items: [],
  });

  const columns: ColumnsType<any> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Avatar style={{ verticalAlign: "middle" }} size="large" gap={5}>
            <GetImage icon={record.thumbnail} />
          </Avatar>
          {text}
        </Space>
      ),
    },
    {
      title: "Description",
      key: "desc",
      dataIndex: "desc",
      width: 250,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
    },
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
    },
    {
      title: "EventType",
      dataIndex: "eventType",
      key: "eventType",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
    },
    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Link to={{ pathname: `/events/${record._id}/edit` }} state={record}>
            <Button icon={<EditFilled />} />
          </Link>
          <Popconfirm
            title="Delete the task"
            description="Are you sure to delete this task?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => {
              handleDelete(record._id);
            }}
          >
            <Button danger size="small" loading={loadingId === record._id}>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const initialise = async () => {
    try {
      setLoading(true);
      let apiRes = await seekSolutionApi.Events.list();
      console.log("apiRes----->", apiRes);

      const newState = {
        Count: apiRes.count,
        ScannedCount: apiRes.data.length,
        Items: apiRes.data.map((item: any) => ({
          ...item,
          createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
        })),
      };
      setState(newState);
      setDefaultState(newState);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleDelete = async (_id: any) => {
    try {
      setLoading(true);
      setLoadingId(_id);
      console.log('_id', _id);
      let apiRes = await seekSolutionApi.Events.delete(_id);
      console.log('api api--->', apiRes);

      if (apiRes) {
        console.log("deleted id", apiRes);
        initialise();
        Toast.openSuccessNotification("Item Deleted Successfully");
      }
    } catch (error) {
      console.error("Error deleting question", error);
    } finally {
      setLoading(false);
      setLoadingId("");
    }
  };

  useEffect(() => {
    initialise();
  }, []);

  const handleSearch = (value: string) => {
    setSearchValue(value);
    const filteredItems = defaultState?.Items?.filter((item: any) =>
      item.title.toLowerCase().startsWith(value.toLowerCase())
    );
    setState((prevState) => ({ ...prevState, Items: filteredItems }));
  };

  return (
    <Fragment>
      <Space direction="vertical" style={{ display: "flex" }}>
        <Breadcrumb
          items={[
            {
              title: "Management",
            },
            {
              title: "Events",
            },
          ]}
        />
        <Title level={2}>Events</Title>
        <Divider />
        <Row gutter={[2, 8]} justify={"space-between"}>
          <Col span={20}>
            <Search
              placeholder="input search text"
              value={searchValue}
              onChange={(e) => handleSearch(e.target.value)}
              enterButton="Search"
            />
          </Col>
          <Col span={4}>
            <Button type="primary" onClick={showDrawer}>
              Filter
            </Button>
            <a href="/events/create">
              <PlusCircleOutlined style={{ fontSize: "28px", marginLeft: "10px" }} />
            </a>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={(state.Items || []).map((res: any, index) => {
            return {
              ...res,
              key: index + 1,
              title: res.title,
              desc: uiSettings.capitalizeFirstLetter(res.desc),
              date: moment(res.date).format("YYYY-MM-DD"),
              time: moment(res.date).format("h:mm a"),
              createdAt: moment(res.createdAt).format("YYYY-MM-DD"),
              link: res.link,
            };
          })}
          pagination={{ hideOnSinglePage: true }}
        />
      </Space>
      <Drawer
        title="Filter"
        placement={"right"}
        width={500}
        onClose={onClose}
        open={open}
        extra={
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button type="primary" onClick={onClose}>
              Apply
            </Button>
          </Space>
        }
      >
        <p>Some contents...</p>
      </Drawer>
    </Fragment>
  );
};

export default EventListing;
